import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocInlineImage, DocModalImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function Users() {
    const { t } = useTranslation();
    const image001 = useDocImage('users-img', 'image001.png', 'settings');
    const image002 = useDocImage('users-img', 'image002.png', 'settings');
    const image003 = useDocImage('users-img', 'image003.png', 'settings');
    const image004 = useDocImage('users-img', 'image004.png', 'settings');
    const image005 = useDocImage('users-img', 'image005.png', 'settings');
    const image006 = useDocImage('users-img', 'image006.png', 'settings');
    const image007 = useDocImage('users-img', 'image007.png', 'settings');

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>

                            <h1 className='mt-0 text-primary'>{t('documentation.users.title')}</h1>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.users.accessing.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.users.accessing.intro')}</p>
                                    <SettingsMenuOverview />
                                    <ul>
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.users.accessing.steps.step1') }} />
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.users.accessing.steps.step2') }} />
                                    </ul>
                                    <DocSidebarImage src={image001} alt={t('documentation.users.accessing.imageAlt')} />
                                    <ul className="mb-0">
                                        <li dangerouslySetInnerHTML={{ __html: t('documentation.users.accessing.steps.step3') }} />
                                    </ul>
                                    <p><b>{t('documentation.users.search.title')}</b></p>
                                    <DocContentImage src={image006} alt={t('documentation.users.search.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.users.search.steps.step1')}</li>
                                        <li>{t('documentation.users.search.steps.step2')}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                    {t('documentation.users.listOverview.title')}
                                </div>
                                <div className="card-body">
                                    <p>{t('documentation.users.listOverview.intro')}</p>
                                    <DocContentImage src={image002} alt={t('documentation.users.listOverview.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.users.listOverview.columns.name')}</li>
                                        <li>{t('documentation.users.listOverview.columns.defaultLanguage')}</li>
                                        <li>{t('documentation.users.listOverview.columns.timezone')}</li>
                                        <li>{t('documentation.users.listOverview.columns.actions')}</li>
                                    </ul>
                                    <DocInlineImage src={image003} alt={t('documentation.users.listOverview.actionsImageAlt')} />

                                    <p><b>{t('documentation.users.editing.title')}</b></p>
                                    <DocModalImage src={image004} alt={t('documentation.users.editing.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.users.editing.steps.step1')}</li>
                                        <li>{t('documentation.users.editing.steps.step2')}</li>
                                        <li>{t('documentation.users.editing.steps.step3')}</li>
                                    </ul>

                                    <p><b>{t('documentation.users.deleting.title')}</b></p>
                                    <DocModalImage src={image005} alt={t('documentation.users.deleting.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.users.deleting.steps.step1')}</li>
                                        <li>{t('documentation.users.deleting.steps.step2')}</li>
                                        <li>{t('documentation.users.deleting.steps.step3')}</li>
                                    </ul>

                                </div>
                            </div>

                            <div className="card dashboard-card mb-4">
                                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                {t('documentation.users.addUser.title')}
                                </div>
                                <div className="card-body">
                                    <DocModalImage src={image007} alt={t('documentation.users.addUser.imageAlt')} />
                                    <ul>
                                        <li>{t('documentation.users.addUser.steps.step1')}</li>
                                        <li>
                                            {t('documentation.users.addUser.steps.step2')}
                                            <ul className='pt-10'>
                                                <li>{t('documentation.users.addUser.fields.fullName')}</li>
                                                <li>{t('documentation.users.addUser.fields.email')}</li>
                                                <li>{t('documentation.users.addUser.fields.password')}</li>
                                                <li>{t('documentation.users.addUser.fields.timezone')}</li>
                                                <li>{t('documentation.users.addUser.fields.defaultLanguage')}</li>
                                                <li>
                                                    {t('documentation.users.addUser.saveAction')}
                                                    <ul className='pt-10'>
                                                        <li>{t('documentation.users.addUser.saveOptions.cancel')}</li>
                                                        <li>{t('documentation.users.addUser.saveOptions.save')}</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                  

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
